import { react2angular } from '@Shared.Angular/flowingly.helper/react2angular';
import { ProcedureBulkImportModal } from './ProcedureBulkImportModal';

const ProcedureBulkImportModalBridge = react2angular(ProcedureBulkImportModal, [
  'onClose'
]);

export default ProcedureBulkImportModalBridge;
